export const CombinationIconWrapper = ({
    icon1,
    icon2,
  }: {
    icon1: React.ReactNode;
    icon2: React.ReactNode;
  }) => (
    <svg
      width="32"
      height="16"
      viewBox="15 12 32 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon-wrapper-flow"
    >
      <g transform="translate(0, 0)">{icon1}</g>
      <g transform="translate(16, 0)">{icon2}</g>
    </svg>
  );